// Common shared defaults for Bootstrap tooltip and popovers.

export default {
  show: 300,
  hide: 100,
};
